import React from "react";

const Shoes = ({ checkboxState, handleCheckboxChange }) => {
  return (
    <div>
      {" "}
      <div
        id="w-node-_9df0ef66-a959-ffff-ccbe-0314e969421b-1538e4e7"
        className="edit-profile-interest-option-div"
      >
        <div className="edit-profile-icon-wrapper intminheight">
          <div className="tabs-nav-icon w-embed">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 79 75"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_25_809)">
                <path
                  d="M77.0715 54.4405C75.2496 54.2949 73.4332 54.3341 71.6225 54.0316C69.0269 53.589 66.4089 53.1297 64.3515 51.4098C64.2169 51.337 64.0768 51.253 63.9366 51.1522C61.6213 49.4043 60.0292 46.6649 58.1905 44.4241C56.5367 42.4074 55.3258 40.1834 54.6643 37.6457C53.1675 31.87 53.0161 25.5229 52.6966 19.5455C48.7163 18.7444 44.8089 17.9433 41.3164 15.316C36.7699 11.8987 33.5913 6.55438 32.969 0.896332C30.0202 2.84584 27.4919 5.99978 25.1318 8.32463C22.2167 11.2041 19.2006 14.2516 16.0276 16.8341C15.7025 17.0974 15.3661 17.2711 15.0185 17.3775L63.1462 65.0396C63.5554 64.7651 64.0712 64.6082 64.6991 64.6138C67.8216 64.6699 71.7066 65.4822 74.5937 63.908C77.5593 62.2946 78.3721 58.362 77.6882 55.3201C77.6265 55.0344 77.6041 54.7655 77.6153 54.5078C77.4359 54.4798 77.2621 54.4574 77.0659 54.4405H77.0715Z"
                  fill="#E2B760"
                />
                <path
                  d="M55.5332 65.723C53.4758 65.723 51.4576 64.8939 49.972 63.4094L15.0522 28.5199C13.561 27.0298 12.7369 25.0411 12.7425 22.9179C12.7425 20.8003 13.5666 18.8116 15.0578 17.3271L31.5058 0.885124C32.2514 0.140053 33.3166 -0.162456 34.3369 0.0840332C35.3684 0.330523 36.1812 1.08119 36.512 2.08956C37.5435 5.25471 39.2702 9.51785 41.6023 11.8483C44.5903 14.8398 50.841 16.8397 53.3861 17.5624C54.5914 17.9041 55.4715 18.9741 55.5724 20.2233L56.7273 34.643C56.8674 36.4188 57.5121 38.1106 58.5773 39.5391L65.9324 49.3483C67.4796 50.4463 68.6401 50.6592 70.3779 50.9841C71.7122 51.2306 73.366 51.5443 75.6476 52.3566C77.0099 52.844 77.9741 53.6955 78.5179 54.8943C79.2411 56.4853 79.1458 58.6197 78.2488 60.9165C77.1276 63.7847 74.2966 65.7062 71.202 65.7062H55.9929C55.8359 65.7174 55.6846 65.723 55.5276 65.723H55.5332ZM33.6249 1.68061C33.2773 1.68061 32.9522 1.81506 32.6943 2.07275L16.2406 18.5147C15.069 19.6855 14.4243 21.2485 14.4187 22.9179C14.4187 24.5929 15.0634 26.1559 16.2406 27.3323L51.1605 62.2274C52.4163 63.4822 54.1653 64.1433 55.9481 64.0368H71.2076C73.6126 64.0368 75.8158 62.5411 76.6903 60.3115C77.4079 58.4684 77.52 56.7542 76.993 55.6002C76.6399 54.8215 76.012 54.2837 75.087 53.9476C72.9343 53.1745 71.4207 52.8944 70.0752 52.6423C68.2308 52.3006 66.7733 52.0261 64.8784 50.6648C64.8336 50.6368 64.7887 50.5976 64.7495 50.5583C64.7159 50.5247 64.6878 50.4911 64.6654 50.4575L57.2374 40.5531C55.9761 38.8725 55.2249 36.8782 55.0567 34.783L53.9019 20.3634C53.857 19.8088 53.4702 19.3382 52.932 19.187C49.6076 18.2458 43.5644 16.1955 40.4138 13.0415C37.8462 10.4758 36.0074 5.95496 34.9199 2.61615C34.7685 2.15678 34.4153 1.83187 33.95 1.71983C33.8435 1.69182 33.737 1.68061 33.6305 1.68061H33.6249Z"
                  fill="#000"
                />
                <path
                  d="M62.6304 65.7118C62.4174 65.7118 62.1988 65.6278 62.0362 65.4653L15.0522 18.5147C14.7214 18.1842 14.7214 17.652 15.0522 17.3271C15.3829 16.9966 15.9155 16.9966 16.2406 17.3271L63.2247 64.2777C63.5554 64.6082 63.5554 65.1404 63.2247 65.4653C63.0621 65.6278 62.8435 65.7118 62.6304 65.7118Z"
                  fill="#000"
                />
                <path
                  d="M36.17 31.9988C35.957 31.9988 35.7384 31.9148 35.5758 31.7523L24.8683 21.0524C24.5375 20.7219 24.5375 20.1897 24.8683 19.8648C25.199 19.5343 25.7316 19.5343 26.0568 19.8648L36.7643 30.5647C37.095 30.8952 37.095 31.4274 36.7643 31.7523C36.6017 31.9148 36.383 31.9988 36.17 31.9988Z"
                  fill="#000"
                />
                <path
                  d="M55.9929 65.7119H0.840903C0.375603 65.7119 0 65.3365 0 64.8716C0 64.4066 0.375603 64.0312 0.840903 64.0312H55.9929C56.4582 64.0312 56.8338 64.4066 56.8338 64.8716C56.8338 65.3365 56.4582 65.7119 55.9929 65.7119Z"
                  fill="#000"
                />
                <path
                  d="M41.2435 75H19.6715C19.2062 75 18.8306 74.6247 18.8306 74.1597C18.8306 73.6947 19.2062 73.3194 19.6715 73.3194H41.2435C41.7088 73.3194 42.0844 73.6947 42.0844 74.1597C42.0844 74.6247 41.7088 75 41.2435 75Z"
                  fill="#000"
                />
                <path
                  d="M59.3341 75H49.5011C49.0358 75 48.6602 74.6247 48.6602 74.1597C48.6602 73.6947 49.0358 73.3194 49.5011 73.3194H59.3341C59.7994 73.3194 60.175 73.6947 60.175 74.1597C60.175 74.6247 59.7994 75 59.3341 75Z"
                  fill="#000"
                />
                <path
                  d="M22.766 47.4884H7.87086C7.40556 47.4884 7.02995 47.1131 7.02995 46.6481C7.02995 46.1832 7.40556 45.8078 7.87086 45.8078H22.766C23.2313 45.8078 23.6069 46.1832 23.6069 46.6481C23.6069 47.1131 23.2313 47.4884 22.766 47.4884Z"
                  fill="#000"
                />
                <path
                  d="M12.4454 56.6029H4.03634C3.57104 56.6029 3.19543 56.2276 3.19543 55.7626C3.19543 55.2977 3.57104 54.9223 4.03634 54.9223H12.4454C12.9107 54.9223 13.2863 55.2977 13.2863 55.7626C13.2863 56.2276 12.9107 56.6029 12.4454 56.6029Z"
                  fill="#000"
                />
                <path
                  d="M28.4169 56.6029H20.5517C20.0864 56.6029 19.7108 56.2276 19.7108 55.7626C19.7108 55.2977 20.0864 54.9223 20.5517 54.9223H28.4169C28.8822 54.9223 29.2578 55.2977 29.2578 55.7626C29.2578 56.2276 28.8822 56.6029 28.4169 56.6029Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_25_809">
                  <rect width={79} height={75} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label className="w-checkbox ms-pill-item">
          <input
            type="checkbox"
            name="checkbox-3"
            id="checkbox-3w"
            data-name="Checkbox 3"
            className="w-checkbox-input ms-pill-checkbox"
            checked={checkboxState.inTheShoesOf}
            onChange={handleCheckboxChange("inTheShoesOf")}
          />
          <span
            className="ms-pill-label has-icon w-form-label"
            htmlFor="checkbox-3"
          >
            In the shoes of
          </span>
          <div className="ms-pill-icon w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
            </svg>
          </div>
        </label>
      </div>
    </div>
  );
};

export default Shoes;
